import { getFusionPCC } from '../apiHelper/fusionApi'

export function getPCCMedications(patientId, startDate = null) {
  return getFusionPCC(
    `v1/patient/pccmedications/${patientId}${startDate ? `?startdate=${startDate}` : ''}`,
    patientId,
  )
}

export function getPCCAllergies(patientId, onsetDate = null) {
  return getFusionPCC(
    `v1/patient/pccallergies/${patientId}${onsetDate ? `?onsetdate=${onsetDate}` : ''}`,
    patientId,
  )
}

export function getPCCImmunizations(patientId, revisionDate = null) {
  return getFusionPCC(
    `v1/patient/pccimmunizations/${patientId}${revisionDate ? `?revisiondate=${revisionDate}` : ''}`,
    patientId,
  )
}

export function getPCCFunctionalStatus(patientId, recordedDate = null) {
  return getFusionPCC(
    `v1/patient/pccactivitiesofdailyliving/${patientId}${recordedDate ? `?recordeddate=${recordedDate}` : ''}`,
    patientId,
  )
}

export function getPCCObservations(patientId, recordedDate = null) {
  return getFusionPCC(
    `v1/patient/pccobservations/${patientId}${recordedDate ? `?recordeddate=${recordedDate}` : ''}`,
    patientId,
  )
}

export function getPCCConditions(patientId, onsetDate = null) {
  return getFusionPCC(
    `v1/patient/pccconditions/${patientId}${onsetDate ? `?onsetdate=${onsetDate}` : ''}`,
    patientId,
  )
}

export function getPCCReport(patient_id, reportType, issuedDate = null) {
  return getFusionPCC(
    `/v1/patient/pccdiagnosticreports/${patient_id}/${reportType}${issuedDate ? `?issueddate=${issuedDate}` : ''}`,
    patient_id,
  )
}

export function getPCCResultFile(patient_id, reportId) {
  return getFusionPCC(`/v1/patient/pccdiagnosticreportfile/${patient_id}/${reportId}`, patient_id, {
    responseType: 'blob',
  })
}

export function getPCCData(patient_id) {
  return getFusionPCC(`/v1/patient/pccdata/${patient_id}`, patient_id)
}

export function getPCCCoverages(patient_id) {
  return getFusionPCC(`/v1/patient/pcccoverages/${patient_id}`, patient_id)
}

export function getPCCNotes(patient_id, date) {
  return getFusionPCC(`/v1/patient/pccnotes/${patient_id}?search_date=${date}`, patient_id)
}

export function getPCCNoteDetails(patient_id, note_id) {
  return getFusionPCC(`/v1/patient/pccnotedetails/${patient_id}/${note_id}`, patient_id)
}
